/**
 * 所有后端配置
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null,null,null,null,null,null,null,null,null]}
 */
const BACKEND_API_CONFIG = [
    {label: 'RS私人订阅地址(https://api.sub.rasing.vip/sub?)', value: "https://api.sub.rasing.vip/sub?"},

    {
        label: 'CloudFlare中转订阅(https://api.sub.966788.xyz/sub?)',
        value: "https://api.sub.966788.xyz/sub?"
    },

    {label: '啦啦云后端(https://sub2.lalayun.us/sub?)', value: "https://sub2.lalayun.us/sub?"},
    {label: '肥羊增强型后端【vless reality+hy1+hy2】(https://api.v1.mk/sub?)', value: "https://api.v1.mk/sub?"},
    {label: '肥羊备用后端【vless reality+hy1+hy2】(https://sub.d1.mk/sub?)', value: "https://sub.d1.mk/sub?"},

    {label: '白月光(Workers反代后端)(https://api.ml1.one/sub?)', value: "https://api.ml1.one/sub?"},
    {
        label: 'つつの专属后端(六核负载均衡-支持IPv4/IPv6)(https://api.tsutsu.one/sub?)',
        value: "https://api.tsutsu.one/sub?"
    },

    {label: 'CordCloud(https://subweb.ccsub.site/sub?)', value: "https://subweb.ccsub.site/sub?"},

    {label: '品云提供-Meta(https://v.id9.cc/sub?)', value: "https://v.id9.cc/sub?"},
    {label: '品云提供-稳定(https://sub.id9.cc/sub?)', value: "https://sub.id9.cc/sub?"},
    {label: '品云提供-专属(https://id9.cc/sub?)', value: "https://id9.cc/sub?"},

    {label: 'SubConverter作者提供-稳定(https://sub.xeton.dev/sub?)', value: "https://sub.xeton.dev/sub?"},
    {label: 'lhie1提供-稳定)(https://api.dler.io/sub?)', value: "https://api.dler.io/sub?"},
    {label: '猫熊提供-稳定(https://sub.maoxiongnet.com/sub?)', value: "https://sub.maoxiongnet.com/sub?"},
]


/**
 * 组合 后端配置
 * @type {{default: *[], custom: *[]}}
 */
const BACKEND_ALL_CONFIGS = {

    // 默认选中的配置
    DEFAULT_BACKEND_API: `https://api.sub.rasing.vip/sub?`,
    // 用于配置 ACL4SSR 的默认配置
    BACKEND_API_CONFIG: BACKEND_API_CONFIG,
}

export default BACKEND_ALL_CONFIGS
